var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMethaneDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6818 4.36364H4.86364V9.81818H14.6818V4.36364Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1364 4.36364H15.7727V6.54545H20.1364V4.36364Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1364 13.0909V7.63636H15.7727V13.0909H20.1364Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22727 10.9091H4.86364V13.0909H9.22727V10.9091Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6818 10.9091H10.3182V13.0909H14.6818V10.9091Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1364 19.6364V14.1818H10.3182V19.6364H20.1364Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22727 17.4545H4.86364V19.6364H9.22727V17.4545Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86364 14.1818H9.22727V16.3636H4.86364V14.1818Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.861 0.63904C23.4518 0.229869 22.8968 0 22.3182 0H2.68182C1.47091 0 0.5 0.970909 0.5 2.18182V21.8182C0.5 22.3968 0.72987 22.9518 1.13904 23.361C1.54821 23.7701 2.10316 24 2.68182 24H22.3182C22.8968 24 23.4518 23.7701 23.861 23.361C24.2701 22.9518 24.5 22.3968 24.5 21.8182V2.18182C24.5 1.60316 24.2701 1.04821 23.861 0.63904ZM22.3182 2.18182V21.8182H2.68182V2.18182H22.3182Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMethaneDashboard);
export default __webpack_public_path__ + "static/media/icon_methane_dashboard.de9d83a9.svg";
export { ForwardRef as ReactComponent };